import { size } from "../foundation";

export const icon = {
    spacing: {      // padding between icon and container edge
        sm: size[25],    // tiny, xs, sm icons
        md: size[50],    // md, lg, xl icons
        lg: size[100],   // huge icons
    },
    size: {
        // In Figma, icon size defines the container. The icon is centered and scales to fill the container (minus the padding). 
        // This mean the size of the actual icon is less than this size. This approach may need to be changed to fit the code implementation.
        tiny: size[300],
        xs: size[350],
        sm: size[400],
        md: size[500],
        lg: size[600],
        xl: size[800],
        huge: size[1000],
    }
}

export default icon;